const splitCsvLine = (line) => {
  const result = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    if (ch === '"') {
      inQuotes = !inQuotes;
      continue;
    }
    if (ch === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
      continue;
    }
    current += ch;
  }
  result.push(current.trim());
  return result;
};

const normalizeHeader = (h) => h.toLowerCase().replace(/[^a-z0-9]/g, '');

export async function parseSkuDeleteCsv(file) {
  const text = await file.text();
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return [];

  const headerCells = splitCsvLine(lines[0]).map(normalizeHeader);
  const skuIdx = headerCells.findIndex(
    (h) => h === 'sku' || h === 'canonicalsku' || h === 'canonical',
  );
  const colIdx = skuIdx >= 0 ? skuIdx : 0;

  const dataLines = skuIdx >= 0 ? lines.slice(1) : lines;
  const values = [];
  for (const line of dataLines) {
    const cells = splitCsvLine(line);
    const val = (cells[colIdx] || cells[0] || '').trim();
    if (val) values.push(val);
  }
  return [...new Set(values)];
}

export async function parseListingDeleteCsv(file) {
  const text = await file.text();
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return [];

  const headerCells = splitCsvLine(lines[0]).map(normalizeHeader);
  const idIdx = headerCells.findIndex(
    (h) =>
      h === 'externalplatformid' ||
      h === 'itemid' ||
      h === 'ebayitemid' ||
      h === 'listingid',
  );
  const colIdx = idIdx >= 0 ? idIdx : 0;

  const dataLines = idIdx >= 0 ? lines.slice(1) : lines;
  const values = [];
  for (const line of dataLines) {
    const cells = splitCsvLine(line);
    const val = (cells[colIdx] || cells[0] || '').trim();
    if (val) values.push(val);
  }
  return [...new Set(values)];
}
